module.exports = __webpack_public_path__ + "media/images/team/maxim-228426aea3bbc234fcc1ac6c30b8dcad.jpg";